import { AlertCircle, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface StoreNotFoundProps {
  error?: string | null;
}

export function StoreNotFound({ error }: StoreNotFoundProps) {
  const defaultMessage = 'Loja não encontrada. Verifique o domínio e tente novamente.';

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center mx-auto">
          <AlertCircle className="w-10 h-10 text-destructive" />
        </div>
        
        <div className="space-y-2">
          <h1 className="font-display text-3xl font-bold text-foreground">
            Loja Não Encontrada
          </h1>
          <p className="text-muted-foreground">
            {error || defaultMessage}
          </p>
        </div>

        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Possíveis causas:
          </p>
          <ul className="text-sm text-muted-foreground space-y-1 text-left max-w-xs mx-auto">
            <li>• O domínio está incorreto</li>
            <li>• A loja foi desativada</li>
            <li>• O subdomínio não existe</li>
            <li>• Erro de conexão com o servidor</li>
          </ul>
        </div>

        <div className="pt-4">
          <Button
            onClick={() => window.location.reload()}
            variant="default"
            className="gap-2"
          >
            <Home className="w-4 h-4" />
            Tentar Novamente
          </Button>
        </div>

        <div className="pt-4 border-t border-border">
          <p className="text-xs text-muted-foreground">
            Se o problema persistir, entre em contato com o suporte.
          </p>
        </div>
      </div>
    </div>
  );
}
